<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <Mlogin />
          <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">Simple Search</div>
                  <div class="title_more2">
                    <a href="/en">Home</a>>Simple Search
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="hidden-sm-and-down fifth">
                    <span class="leftfloat"><el-input @keyup.enter="Search" v-model="value"
                        placeholder="Title, Author, Keyword, Abstract" size="small"
                        style="width: 230px"></el-input></span>
                    <span class="leftfloat ml1"><el-button @click="Search" type="primary"
                        size="small">Search</el-button></span>
                    <span class="leftfloat ml1 highsearch"><a style="cursor: pointer"
                        @click="goAdvSear">Advanced Search </a></span>
                    <div class="clearfix"></div>
                  </div>
                  <div class="fifth" v-loading="isloading">
                    <div class="msg_error" v-if="tabcontent.length <= 0 && isquick">
                      No result found.
                    </div>
                    <article-list :List="tabcontent" :ischeckbox="true" :iscount="true" :count="indexs" :type="0"
                      :allcheckedshow="true" @allchecked="allchecked" v-if="isquick">
                    </article-list>
                  </div>
                </div>
                <common-page v-if="isquick" :count="indexs" @pageSize="pageSize" @pageindex="index"
                  :index="paramas"></common-page>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'default_result',
  data() {
    return {
      value: '',
      Ishtml: true,
      tabcontent: [],
      activeNames: [],
      indexs: 0,
      num: 1,
      size: 10,
      isloading: true,
      PageIndex: 0,
      isquick: false,
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
    }
  },
  components: {},
  mounted() {
    this.value = localStorage.getItem('value')
    this.Search()
  },
  beforeMount() { },
  methods: {
    allchecked() {
      this.tabcontent.map((item) => {
        item.checked = true
      })
    },
    postGoin() {
      let ids = ''
      this.tabcontent.map((item) => {
        if (item.checked) {
          ids += item.ArticleID + ','
        }
      })
      var arr = ids.split('')
      arr.splice(arr.length - 1, 1)
      ids = arr.join('')
      this.$newOpen('/#/Export?ids=' + ids)
    },
    //搜索
    async Search() {
      if (this.value == '' || this.value == null) {
        this.isloading = false
        this.isquick = false
        return
      } else {
        this.isloading = true
        this.isquick = true
      }
      let data = {
        PageIndex: this.num,
        PageSize: this.size,
        SearchKey: [
          {
            Type: 'All',
            Key: this.value,
          },
        ],
      }
      let Res = await this.$store.dispatch('_postSearch', data)
      this.isloading = false
      if (Res.data.IsSuccess) {
        this.tabcontent = Res.data.Data
        this.indexs = Res.data.ItemCount
        if (this.tabcontent.length > 0) {
          this.tabcontent.forEach((item) => {
            item.TitleE = this.$brightkeyWords(item.TitleE, this.value)
          })
          this.show = false
        } else {
          this.show = true
        }
      }
    },
    async pageSize(val) {
      this.size = val
      this.paramas.PageSize = val
      this.Search()
    },
    async index(val) {
      this.num = val
      this.paramas.PageIndex = val
      this.Search()
    },
    goAdvSear() {
      let routeUrl = this.$router.resolve({
        path: '/AdvancedSearch',
      })
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>

<style scoped></style>
